<div
  class="card d-flex flex-column justify-content-start view-offer-tile"
  [id]="perkID + '-tile'"
  trackClickEvent
  [eventNumber]="perk.widget.redirectUri ? ClickEventNumbersEnum.TileOpensLink : ClickEventNumbersEnum.TileOpensModal"
  [eventDetails]="perk.tag"
  (click)="selectPerk()">
  <div
    *ngIf="!enabled || preview"
    class="overlay d-flex flex-column justify-content-center align-items-center text-center"
    [ngClass]="{
      'preview-mode' : preview,
      'disabled' : !enabled
    }"
    [routerLink]="preview ? ['/account/account-type'] : []">
      <fa-icon
        class="mb-5"
        [icon]="['fas', 'lock']"
        size="5x">
      </fa-icon>
      <h5>
        {{ enabled ? 'Upgrade to Premium to use this perk' : disabledText }}
      </h5>
  </div>
  <div>
    <div
    class="card-img-top"
    [ngClass]="{'d-sm-none': widgetSize == WidgetSizeEnum.Large}"
    >
    <img class="card-image" [src]=perk.widget.image [alt]=perk.widget.heading>
    </div>
  </div>
  <!-- <div>
    <div
    class="card-img-top"
    [ngClass]="{'d-sm-none': widgetSize == WidgetSizeEnum.Large}"
    [ngStyle]="{'background-image': 'url(' + perk.widget.image + ')'}"
    >
    </div>
  </div> -->
  <div
    *ngIf="widgetSize == WidgetSizeEnum.Large"
    class="d-none d-sm-inline-block card-img-top" style="min-width: 100%;">
    <img class="card-image" [src]=perk.widget.imageFeatured [alt]=perk.widget.heading>
  </div>
  <div class="card-body d-flex flex-column align-items-start justify-content-start">
    <div class="card-title" [innerHTML]="perk.widget.heading"></div>
    <p class="card-description" [innerHTML]="perk.widget.description"></p>
    <p *ngIf="perk.widget.footerText" class="footer" [innerHtml]="perk.widget.footerText"></p>
    <button
      class="btn w-100 btn-md text-white view-offer"
      [id]="perkID"
      [ngStyle]="{
        'background-color': perk.color,
        'font-weight': widgetSize == WidgetSizeEnum.Large ? 'bold' : 'regular'
      }"
      [disabled]="preview">
      <span [id]="perkID + '-btext'"> {{ perk.widget.buttonLabel ? perk.widget.buttonLabel : 'View offer' }}</span>
    </button>
  </div>
</div>
